import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import {IOption} from '../select/option.interface';
import {FormFieldControlDirective} from '../form-field/directives';
import {Subject} from 'rxjs';
import {DropdownAnimation} from '../select/dropdown.animation';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-multiselect',
  templateUrl: './multiselect.component.html',
  styleUrls: ['./multiselect.component.scss'],
  animations: [DropdownAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {provide: FormFieldControlDirective, useExisting: MultiselectComponent},
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiselectComponent),
      multi: true,
    },
  ],
})
export class MultiselectComponent implements FormFieldControlDirective<number[]>, OnChanges {
  focused: boolean = false;
  controlType: string = 'select';
  stateChanges: Subject<void> = new Subject<void>();

  @Input() options?: IOption[];
  @Input() placeholder!: string;
  @Input() disabled: boolean = false;

  @Input()
  get value(): number[] {
    return this._value;
  }

  set value(newValue: number[] | undefined | null) {
    this._value = newValue || [];
  }

  private _value: number[] = [];

  @Output() onChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private _elementRef: ElementRef<HTMLDivElement>,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    // this.cdr.detectChanges();
    // if (changes['options']) this.value = [];
  }

  _onChange: (value: any) => void = () => {
  };
  _onTouched = () => {
  };

  writeValue(value: any): void {
    this.value = value;
    // this.model = this.renderValue();
  }

  registerOnChange(fn: (value: any) => void): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: () => {}): void {
    this._onTouched = fn;
  }

  toggle() {
    this.focused = !this.focused;
    this.stateChanges.next();
  }

  checkboxToggle(value: number) {
    if (this.checkSelected(value)) {
      this.value = this.value.filter((v: number) => v !== value);
    } else {
      this.value = [...this.value, value];
    }
    this.onChange.emit(this.value);
    this.stateChanges.next();
  }

  renderCheckbox(value: number): string {
    return `icon-checkbox${this.checkSelected(value) ? '-selected' : ''}`;
  }

  renderValue(): string {
    return this.value.length ? `${this.translate.instant(`GENERAL_INFORMATION_SELECTED_NUMBER_PLACEHOLDER`
    )} ${this.value.length}` : this.placeholder;
  }

  checkSelected(value: number): boolean {
    return this.value.includes(value);
  }

  @HostListener('document:click', ['$event.target'])
  outsideClick(targetElement: Node | null): void {
    if (this.focused && !this._elementRef.nativeElement.contains(targetElement)) {
      this.toggle();
    }
  }
}
